import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { download, validateAllFormFields } from 'src/app/shared/utils/calsoft-validators';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { MatStepper } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { DealsEntityService } from 'src/app/services/deals-entity.service';

@Component({
  selector: 'calsoft-deals-import',
  templateUrl: './deals-import.component.html',
  styleUrls: ['./deals-import.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
  
})
export class DealsImportComponent implements OnInit, OnDestroy{

  url = '';
  sanitizedUrl = '';


  @ViewChild('fileInput') fileInput: ElementRef;
  protected _onDestroy = new Subject<void>();

  fileAttr = 'Choose File';
  title: string;
  productImport: boolean;
  firstFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  attributeSetList: any;
  textAdd: string;
  mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');

  productIdUploaded: any;
  text: string;
  successList: any;
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();
  excelTemplateUploaded: any = false;
  failedList: any;
  zipStatus: boolean;
  zipFailedList: any;
  filteredAttributeList: any;
  orientation: string;
  constructor(private router: Router,
    private formBuilder: UntypedFormBuilder,
    private attributeService: AttributesetService,
    public loc: Location,
    private snackBar: MatSnackBar,
    private mediaMatcher: MediaMatcher,
    private dealsEntityService: DealsEntityService,

  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  isLinear = false;

  secondFormGroup: UntypedFormGroup;
  @ViewChild('horizontalStepper', { static: true }) horizontalStepper: MatStepper;
  @ViewChild('verticalStepper', { static: true }) verticalStepper: MatStepper;



  ngOnInit(): void {

    if (window.innerWidth > 768) {
    this.orientation="horizontal"
    }else{
      this.orientation="vertical"
    }
    this.text = "Upload";
    this.createAttributeForm();
    this.getAttributeSetDropDown();
    this.attributeSetFilter();
    this.s();
    this.secondFormGroup = this.formBuilder.group({
      status: ['', Validators.required]
    });

    this.thirdFormGroup = this.formBuilder.group({
      status: ['', Validators.required]
    });
    this.textAdd = 'Download Template'

    if (this.router.url.includes("/import-deals")) {

      this.title = 'Import Deals'

      this.productImport = true;

      // this.getAttributeGroup();
    }

    else {
      this.title = 'Export Deals'
      this.createAttributeForm();

      this.productImport = false;

    }



  }

  back() {
    this.loc.back();
  }
  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
      this._onDestroy.next();
      this._onDestroy.complete();
  }

  createAttributeForm() {
    this.firstFormGroup = this.formBuilder.group({
      attributeSet: ['', Validators.required],
      type: [''],
    });
  }

  getAttributeSetDropDown() {
    this.attributeService.getAttributeSetDropDownList(11).subscribe(
      res => {
        this.attributeSetList = res;

        this.filteredAttributeList = this.attributeSetList;

      },
      error => {

      }
    )
  }



  createAttributeValidations = {
    'attributeSet': [
      { type: 'required', message: 'Please fill out this field.  ' },
    ],
    'type': [
      { type: 'required', message: 'Please fill out this field.' },
    ],

  }


  productType: any = [
    "simple"
  ]

  uploadFileEvt(imgFile: any) {
    if (imgFile.target.files && imgFile.target.files[0]) {
      this.fileAttr = '';
      Array.from(imgFile.target.files).forEach((file: File) => {
        this.fileAttr += file.name + ' - ';
      });

      // HTML5 FileReader API
      let reader = new FileReader();
      reader.onload = (e: any) => {
        let image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          let imgBase64Path = e.target.result;
        };
      };
      reader.readAsDataURL(imgFile.target.files[0]);

      // Reset if duplicate image uploaded again
      this.fileInput.nativeElement.value = "";
    } else {
      this.fileAttr = 'Choose File';
    }
  }

  getExcelTemplate() {

    if ((this.textAdd == 'Download Template') && this.firstFormGroup.valid) {
      this.textAdd = "Processing"
      this.dealsEntityService.downloadDealsReport(this.firstFormGroup.value.attributeSet).subscribe(
        data => {
          this.textAdd = "Download Template"
          download(data);

        }, error => {
          this.textAdd = "Download Template"
        }
      )

    } else {
      this.textAdd = "Download Template";
      validateAllFormFields(this.firstFormGroup)
    }

  }

  @ViewChild("#myInput")
  myInputVariable: ElementRef;

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['xls'],
    //maxFileSize: 5 * 1024 * 1024
  });

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }
  item: FileLikeObject;
  s() {
    let maxFileSize = 5 * 1024 * 1024;
    let queueLimit = 5;
    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      let message = '';

      this.item = item;
      switch (filter.name) {
        case 'fileType':
          this.snackBar.open("uploaded wrong file type, " + item.name, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.myInputVariable.nativeElement.value = "";
          this.uploader.clearQueue();
          break;
        case 'fileSize':
          this.snackBar.open("  The file could not be uploaded because it exceeds 5mb,the maximum allowed size for uploads ", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.myInputVariable.nativeElement.value = "";
          this.uploader.clearQueue();
          break;
        default:
          break;
      }
    };

  }


  upload() {
    let files = this.getFiles();
    let dataExport = new FormData();
    files.forEach((file) => {
      dataExport.append('file', file.rawFile, file.name);
    });
    console.log(this.secondFormGroup)
    this.text = "Processing"
    this.dealsEntityService.excelImportDeals(dataExport, this.firstFormGroup.value.attributeSet).subscribe(
      res => {

        if (res['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(res['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

          this.productIdUploaded = res['datas']

          this.successList = res['data']['Sucess'];

          this.failedList = res['data']['Failed'];
          this.excelTemplateUploaded = true;

          this.secondFormGroup.value.status = true;

          this.secondFormGroup.get("status").setValue("true");
          this.text = "Upload"
          this.uploader.clearQueue();

          console.log(this.secondFormGroup)

          console.log(this.successList)

          console.log(this.excelTemplateUploaded)

        }
        else {
          this.snackBar.open(res['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.text = "Upload"
        }
      },
      error => {
        this.text = "Upload"
      }
    );
  }

  close() {

  }


  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  goToStep2(stepper: MatStepper) {

    if (this.firstFormGroup.valid) {
      stepper.next();
    } else {
        this.firstFormGroup.markAllAsTouched();
    }

  }

  goToStep3(stepper: MatStepper) {

    console.log(this.secondFormGroup)
    if (this.secondFormGroup.value.status && this.secondFormGroup.valid) {
      stepper.next();
    }

  }



  goForward(stepper: MatStepper) {
    console.log(this.thirdFormGroup)
    if (this.thirdFormGroup.value.status && this.thirdFormGroup.valid) {
      stepper.next();
    }
  }

  goToProductPage() {
    this.router.navigate([`/deals`])

  }

  getResult(event) {


    console.log(event)
    if (event['status_code'] == Constant.RESPONSE_SUCCESS) {
      this.thirdFormGroup.get("status").setValue("true");
      this.zipStatus = true;
      console.log()
      if (event.datalist[1]['failure'] != null) {
        this.zipFailedList = event.datalist[1]['failure'];
      } else {
        this.zipFailedList = [];
      }
      console.log(this.zipFailedList)
    } else {
      this.snackBar.open(event['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    }


  }

  attributeSetFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }


  protected attributeFilter() {
    if (!this.attributeSetList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeList = this.attributeSetList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeList = this.attributeSetList.filter(attributeSetName => attributeSetName['attributeSetName'].toLowerCase().indexOf(search) > -1)
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
